import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from '../config-service/config-service';

declare var google: any;
/*
  Generated class for the GeolocationServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GeolocationServiceProvider {
  constructor(private http: HttpClient, private configService: ConfigServiceProvider) {
  }

  getLatLong(address) {
    return new Promise((resolve, reject) => {
      let geoCoder = new google.maps.Geocoder();
      address += ' Polska';
      geoCoder.geocode({'address': address}, (results, status) => {
        if(status === 'OK') {
          let city = results[0].address_components.filter(v => v.types.includes("locality"))[0];
          let street = results[0].address_components.filter(v => v.types.includes("route"))[0];
          let street_number = results[0].address_components.filter(v => v.types.includes("street_number"))[0];
          if(!city || !street || !street_number) {
            reject('too_general');
          } else {
            resolve({ location: results[0].geometry.location, city: city.long_name, street: street.long_name + ' ' + street_number.long_name});
          }
        } else {
          reject(status)
        }
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/modules/core/services/geolocation-service/geolocation-service.ts